import React from 'react';
import PropTypes from 'prop-types';
import { compactNumberFormat, standardNumberFormat, t } from '@cyberint/common-utils';

import { CustomTooltip } from '../Poppers';
import Icons, { IconSizes } from '../Icons';
import { Themes } from '../../style/theme-consts';

import * as S from './styled';

const ConsumptionWidget = ({
  isLoading,
  used,
  total,
  title,
  tooltipMessage,
  errorMessage,
  mode = Themes.DARK,
  testId = 'consumption',
  totalTitle
}) => {
  const percentageValue = total && used ? (used / total) * 100 : 0;
  const isExceed = used > total;
  return (
    <S.Container className={mode} data-testid={testId}>
      <S.TitleWrapper>
        {isLoading ? (
          <S.CircularProgress size={14} />
        ) : (
          <CustomTooltip
            title={`${t('licensing.utilized')} ${standardNumberFormat(used)}`}
            mode={mode}
            placement="bottom">
            <S.ConfiguredCount data-testid={`used-${testId}`} data-value={used}>
              {compactNumberFormat(used) || t('common.na')}
            </S.ConfiguredCount>
          </CustomTooltip>
        )}

        {title && (
          <>
            <S.Title data-testid={`title-${testId}`}>{title}</S.Title>
            {tooltipMessage && (
              <CustomTooltip title={tooltipMessage} mode={mode} placement="bottom">
                <div>
                  <Icons.Info size={IconSizes.S} />
                </div>
              </CustomTooltip>
            )}
            {(errorMessage || isExceed) && (
              <CustomTooltip
                title={errorMessage || t('validation.exceeded', { count: Math.abs(total - used) })}
                mode={mode}
                data-testid={`error-${testId}`}
                placement="bottom">
                <div>
                  <Icons.Error size={16} color="var(--severityRed)" />
                </div>
              </CustomTooltip>
            )}
          </>
        )}
      </S.TitleWrapper>
      <S.ProgressWrapper>
        {isLoading ? (
          <S.Skeleton variant="rounded" height={8} />
        ) : (
          <S.LinearProgress
            value={percentageValue > 100 ? 100 : percentageValue}
            variant="determinate"
            $error={isExceed}
          />
        )}
        {isLoading ? (
          <S.CircularProgress size={14} />
        ) : (
          <CustomTooltip
            title={`${totalTitle || t('licensing.license')} ${standardNumberFormat(total)}`}
            mode={mode}
            placement="bottom">
            <S.TotalCount data-testid={`total-${testId}`} data-value={total}>
              {compactNumberFormat(total) || t('common.na')}
            </S.TotalCount>
          </CustomTooltip>
        )}
      </S.ProgressWrapper>
    </S.Container>
  );
};

ConsumptionWidget.propTypes = {
  isLoading: PropTypes.bool,
  total: PropTypes.number.isRequired,
  used: PropTypes.number.isRequired,
  title: PropTypes.string,
  testId: PropTypes.string,
  tooltipMessage: PropTypes.node,
  errorMessage: PropTypes.node,
  mode: PropTypes.string,
  totalTitle: PropTypes.string
};

export default ConsumptionWidget;
